import { createApiDescription } from "../../helperFunctions";

export const organizerArchiveInfo = {
    archivedOrganizers: createApiDescription(
        "This API can be called to get a list of Organizers present in Archived Organizers with various filters applied in the request.",
        [
            "Archived Organizers API provide results based on the given filters on the request headers and if no filter values are given, it provides results based on default value mapped with all filters.",
            "The default number of Organizers in the response will be 10."
        ]
    ),
    deleteOrganizer: createApiDescription(
        "This API can be called to delete archived organizers and move them to the recycle bin.",
        [
            "Organizer API will be used to delete organizers if only present in Archived Organizers report page.",
            "Delete Organizer API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Delete Organizer API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    moveToDelivered: createApiDescription(
        "This API can be called to move archived organizers back to delivered organizers report.",
        [
            "Move to Delivered API will be used to move organizers if only present in Archived Organizers report page.",
            "Move to Delivered API supports Callback mechanism, callbackUri can be configured in the request body with callback-api-key in the request header. Once request is sent from Move to Delivered API, the response will be posted to the configured callback endpoint URL."
        ]
    ),
    resendAccessLink: createApiDescription(
        "This API can be called to Resend the Access Link to an organizer based on client’s signer guid.",
        [
            "Resend Access Link API will be used to resend the access link to users if the given organizer is present in Archived Organizers report page. Client's signer guid can be get from GET Signer Details API."
        ]
    ),
    signerDetails: createApiDescription(
        "This API can be called to fetch the details of Signers for an organizer.",
        [
            "Signer Information API will be used to get Signer Details if the organizer is present in Archived organizer report page."
        ]
    )
}